export enum EnumModuleId {
    ConfigurationOverview = 4,
    EqTargetCost = 6,
    CSTargetCost =7,
    SCMTargetCost = 8,
    LocalCostTargetCost = 9,
    InvestmentPlantargetCost = 10,
    DirectCostTargetCost = 12,
}